/**
 * 在 iframe 子页面中打开门户「导出任务已提交」提示弹窗
 */
export function showExportTaskSubmittedTip() {
    try {
        if (window.parent && window.parent !== window && window.parent.vue && typeof window.parent.vue.showExportTaskSubmittedTip === "function") {
            window.parent.vue.showExportTaskSubmittedTip()
            return true
        }
    } catch (e) {
        // 跨域 iframe 无法访问 parent
    }
    return false
}

/**
 * 在 iframe 子页面中打开门户「导出记录」弹窗
 */
export function showExportRecords() {
    try {
        if (window.parent && window.parent !== window && window.parent.vue && typeof window.parent.vue.showExportRecords === "function") {
            window.parent.vue.showExportRecords()
            return true
        }
    } catch (e) {
        // 跨域 iframe 无法访问 parent
    }
    return false
}
